export const MOVIE_RATING_VALUES = ['disliked', 'liked', 'loved'] as const;

export type MovieRatingValueType = (typeof MOVIE_RATING_VALUES)[number];
